module.exports = __webpack_public_path__ + "/login_ui/img/hu-a24910ba474996dc9102a18aa820934f.svg";